export const FETCH_USER = 'fetch_user';
export const UPDATE_USER = 'update_user';
export const RESET_INTERVIEW_DATA = 'RESET_INTERVIEW_DATA';
export const SET_INTERVIEW_DATA = 'SET_INTERVIEW_DATA';
export const UPDATE_SUBSCRIPTION = 'update_subscription'; 